<template>
  <div>
    <the-breadcrumbs></the-breadcrumbs>
    <page-content page-title="Neue Kartensammlung">
      <map-collection-form
        :map-collection="mapCollection"
        submit-label="Eintrag anlegen"
        :form-submitted="saveMapCollection"
        mode="new"
      ></map-collection-form>
    </page-content>
  </div>
</template>

<script>
import TheBreadcrumbs from "@/components/TheBreadcrumbs"
import PageContent from "@/components/PageContent"
import MapCollectionForm from "@/components/forms/MapCollectionForm"
import MapCollectionsRepository from "@/repositories/map_collections_repository.js"
import ApiErrorHandlerMixin from "@/mixins/api_error_handler.js"

export default {
  metaInfo: {
    title: "Kartensammlung erstellen"
  },
  components: {
    TheBreadcrumbs,
    PageContent,
    MapCollectionForm
  },
  mixins: [ApiErrorHandlerMixin],
  data() {
    return {
      mapCollection: {
        name: ""
      }
    }
  },
  computed: {
    persisted() {
      return this.mapCollection.hasOwnProperty("id")
    }
  },
  async created() {},
  methods: {
    async saveMapCollection(mapCollection) {
      if (this.persisted) {
        await MapCollectionsRepository.update(mapCollection.id, mapCollection)
      } else {
        await MapCollectionsRepository.create(mapCollection)
      }

      this.$router.push({ name: "MapCollectionsPage" })
    }
  }
}
</script>
